var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"WarningIrreversible"},[_c('v-icon',{attrs:{"color":"red lighten-2"}},[_vm._v("warning")]),_c('span',{staticClass:"body-2 pl-2"},[_vm._v("This action cannot be undone. ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }